export default __webpack_public_path__ + "static/VD_progress4-9d1a320b3674c95b4ca61faf6398aad8.jpg";